import React from 'react';
import { MarketingHead } from '../components/marketing/MarketingHead';
import { WhoWeAreSection } from '../components/WhoWeAreSection';

const WHO_WE_ARE_HEAD = {
  title: 'Quiénes somos | Áncora Automations',
  description:
    'Conoce Áncora, una empresa nacida en Madrid que conecta atención al cliente, herramientas de negocio y seguimiento con las personas siempre al mando.',
  imagePath: '/og-image.png',
  imageAlt: 'Áncora Automations, IA conectada a la atención al cliente y las herramientas del negocio',
  schema: {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: 'Quiénes somos',
    url: 'https://www.ancoraautomations.es/quienes-somos',
    description:
      'Áncora es una empresa nacida en Madrid que conecta la atención al cliente con las herramientas del negocio y mantiene a las personas al mando.',
    mainEntity: {
      '@type': 'Organization',
      name: 'Áncora Automations',
      url: 'https://www.ancoraautomations.es/',
    },
  },
} as const;

export const WhoWeAre: React.FC = () => (
  <div className="marketing-shell" data-surface="who-we-are-page">
    <MarketingHead path="/quienes-somos" {...WHO_WE_ARE_HEAD} />
    <WhoWeAreSection />
  </div>
);
